"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubModeEntreeRelation = void 0;
exports.ESubModeEntreeRelation = {
    rdv_physique: "rdv_physique",
    rdv_distance: "rdv_distance",
};
